<div class="toggle-container" *ngIf="!!showToggleButton">
  <app-button
    childItemsToAnim
    class="btn-toggle"
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    sizeType="large"
    icon="assets/icons/arrow-left.svg"
    (click)="onBtnToggleClick($event)"
    [@handleOpened]="!!openedState"
  ></app-button>
</div>

<div class="logo-container">
  <div class="logo-content">
    <img
      *ngIf="!!showLogo"
      childItemsToAnim
      [@logoOpened]="!!openedState"
      class="logo"
      src="assets/logo-anacom.svg"
      (click)="onLogoClickInternal($event)"
    />
  </div>
</div>

<div class="menu-items-container">
  <div class="menu-items-content" #menuItemsContentEl>
    <app-tree-list
      class="tree-list"
      [items]="menuItems"
      [textEnabled]="isTextShown"
      [tooltipEnabled]="false"
      [textEllipsisMode]="true"
      [openedIndicatorEnabled]="!!openedInternal"
      (onItemClick)="onTreeItemClick($event)"
    ></app-tree-list>
  </div>
</div>

<div>
  <ng-content select="[side-menu-footer]"></ng-content>
</div>
